import { IRewardData } from '../RewardHelper';
import { PreBoosterType } from '../../State/Card/BoosterType';

export interface IAdvertisementPlacement {
    id: string;
    type: AdvertisementType;
}

export enum AdvertisementType {
    INTERSTITIAL = 'interstitial',
    REWARDED = 'rewarded',
    WATCH_TO_PLAY = 'watchToPlay',
}

export interface IAdvertisementPayload {
    g_gameArea: AdvertisementArea;
    reward: IRewardData;
    levelPayload?: {
        levelNumber: number;
        preBoosters: PreBoosterType[];
    };
    [key: string]: any;
}

export enum AdvertisementArea {
    FREE_COINS = 'free_coins',
    COIN_BAR = 'coin_bar',
    LEVEL_COMPLETE = 'level_complete',
    NO_COINS_MENU = 'no_coins_menu',
    WATCH_TO_PLAY = 'watch_to_play',
    DOUBLE_HARVEST = 'double_harvest'
}
